export default function replaceText(dictionary = {}, text = '') {
  let newText = text;

  Object.entries(dictionary).forEach(([key, replacer]) => {
    newText = newText.replaceAll(key, replacer);
  });

  return newText;
}
